import { useMemo, useState } from 'react'

import FilePreview from '../add-file-mapping/FilePreview'
import './index.scss'
import CopyFileMappingWrapper from './CopyFileMappingWrapper'

const CopyFileMapping = () => {
  const [fileContainsHeaderRow, setFileContainsHeaderRow] = useState<boolean>(true)
  const [fileData, setFileData] = useState<Array<Array<string>>>([])
  const [columnDefs, setColumnDefs] = useState<any>([])
  const [isTxtFile, setIsTxtFile] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const headerRows = useMemo(() => {
    return fileContainsHeaderRow
  }, [fileContainsHeaderRow])

  const data = useMemo(() => {
    return fileData
  }, [fileData])

  const defs = useMemo(() => {
    return columnDefs
  }, [columnDefs])

  const isTxt = useMemo(() => {
    return isTxtFile
  }, [isTxtFile])

  return (
    <CopyFileMappingWrapper
      setFileContainsHeaderRow={setFileContainsHeaderRow}
      setFileData={setFileData}
      setColumnDefs={setColumnDefs}
      setIsTxtFile={setIsTxtFile}
      setLoading={setLoading}
    >
      <FilePreview
        fileContainsHeaderRow={headerRows}
        fileData={data}
        columnDefs={defs}
        isTxtFile={isTxt}
        loading={loading}
      />
    </CopyFileMappingWrapper>
  )
}

export default CopyFileMapping
